/**
 * Created by sange on 16/08/2017.
 */

export const MenuRoutes = {
  profile: '/profile',
  teams: '/teams',
  rights: '/rights',
  reports: '/report',
  logout: '/logout',
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/menu-actions.ts